import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { DataTableSortStatus } from 'mantine-datatable';
import { TPersona, ITopicListItem } from '@newo/api/gateway';
import { APP_VERSION } from '@/const';

type IAKBState = {
    persona?: TPersona;
    setPersona: (persona: TPersona) => void;
    sortStatus: DataTableSortStatus<ITopicListItem>;
    setSortStatus: (sortStatus: DataTableSortStatus<ITopicListItem>) => void;
    scoreThreshold: number;
    setScoreThreshold: (scoreThreshold: number) => void;
    flush: () => void;

    // Personas search
    withAgentFlag: boolean;
    toggleWithAgentFlag: () => void;
};

const initialState = {
    persona: undefined,
    scoreThreshold: 0.3,
    withAgentFlag: false
};

const useAKBStore = create<IAKBState>()(
    persist(
        (set) => ({
            ...initialState,
            setPersona: (persona) => {
                set({ persona });
            },
            sortStatus: {
                columnAccessor: 'created_at',
                direction: 'asc'
            },
            setSortStatus: (sortStatus) => {
                set({ sortStatus });
            },
            setScoreThreshold: (scoreThreshold) => {
                set({ scoreThreshold });
            },
            flush: () => {
                set(initialState);
            },
            toggleWithAgentFlag: () => {
                set((state) => ({ withAgentFlag: !state.withAgentFlag }));
            }
        }),
        {
            name: 'akb-store',
            storage: createJSONStorage(() => globalThis.localStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);

export default useAKBStore;
